import { State } from './types';
import underwritingReducerData from '../cases/underwriting/reducerData';
import pepperReviewReducerData from '../cases/pepperReview/reducerData';
import { Nullable } from 'utils/types';
import { TSubPages } from '../subPages/types';

export const createState = <T extends object, E, TCaseErrors extends Nullable<object>>(
  data: T,
  error: E,
  caseErrors: TCaseErrors,
  subPages: TSubPages,
): State<T, E, TCaseErrors> => {
  return {
    data,
    initialData: data,
    error,
    errorModal: null,
    isLoaded: false,
    isPending: false,
    processedFields: [],
    products: [],
    readonlyFields: {
      applicants: [
        {
          futureIncome: {
            minimumRetiredIncome: null,
            futureIncomePensionIncome: null,
            futureIncomeTotalIncome: null,
          },
          currentIncome: {
            currentIncomeEmployedTotal: null,
            currentIncomeSelfEmployedTotal: null,
            currentIncomeOtherTotal: null,
            currentIncomeTotal: null,
            currentIncomePensionIncome: null,
          },
          age: null,
          commitmentRemaining: { balance: 0, monthlyAmount: 0 },
          commitmentToBeCleared: { balance: 0, monthlyAmount: 0 },
        },
        {
          futureIncome: {
            minimumRetiredIncome: null,
            futureIncomePensionIncome: null,
            futureIncomeTotalIncome: null,
          },
          currentIncome: {
            currentIncomeEmployedTotal: null,
            currentIncomeSelfEmployedTotal: null,
            currentIncomeOtherTotal: null,
            currentIncomeTotal: null,
            currentIncomePensionIncome: null,
          },
          age: null,
          commitmentRemaining: { balance: 0, monthlyAmount: 0 },
          commitmentToBeCleared: { balance: 0, monthlyAmount: 0 },
        },
      ],
      applicationDate: null,
      caseId: null,
      numberOfApplicants: null,
      debtToIncome: null,
      ltv: null,
      productFee: null,
      productFixedInterestRate: null,
      productFixedTerm: null,
      productReversionRate: null,
      valuationFeeAmount: null,
      grossLoan: null,
      upfrontCommissionAmount: null,
      ongoingCommissionAmount: null,
      admin: {
        expectedMaturity: null,
        pepperUploadDate: null,
      },
      networkName: null,
      clubName: null,
      commissionPaidTo: null,
      submissionRoute: null,
    },
    history: [],
    refresh: {
      shouldRefresh: false,
      fieldsToRefresh: [],
    },
    dueDiligence: {
      status: null,
    },
    underwriting: underwritingReducerData,
    pepperReview: pepperReviewReducerData,
    permission: {
      isReadonly: false,
    },
    caseErrors,
    subPages,
  };
};
